var _defs, _g, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWthLogo(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 349.3 62.3",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .st0, .st1 {\n        fill: #231f20;\n      }\n\n      .st1 {\n        stroke: #231f20;\n        stroke-miterlimit: 10;\n        stroke-width: .1px;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M10.5,5.6h3.9l6.7,23.9h0l7.2-23.9h3.9l7.2,23.9h0l6.8-23.9h3.7l-8.6,28.8h-3.8l-7.3-24.4h0l-7.3,24.4h-3.8L10.5,5.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M88,5.6h3.3l12.5,28.8h-4.1l-3-7.1h-14.7l-3,7.1h-3.9l12.9-28.8ZM89.6,10h0l-6.1,14.2h12l-5.8-14.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M107.7,5.6h7.5c1.4,0,2.8,0,4.2.2,1.4.2,2.6.5,3.8,1.1,1.1.5,2,1.3,2.7,2.4.7,1,1,2.5,1,4.2s-.7,3.8-2,5.1c-1.3,1.3-3.1,2.1-5.4,2.5l8.3,13.3h-4.3l-8-12.9h-4.5v12.9h-3.5V5.6ZM111.2,18.3h3.1c1,0,2,0,3,0,1,0,2-.2,2.9-.5.9-.3,1.6-.8,2.2-1.4.6-.6.9-1.6.9-2.7s-.2-1.9-.6-2.5c-.4-.6-1-1.1-1.6-1.4-.7-.3-1.4-.6-2.3-.7-.8-.1-1.7-.2-2.6-.2h-4.9v9.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M164.3,8.7h-9.7v25.6h-3.5V8.7h-9.7v-3.2h22.9v3.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M168.4,5.6h3.5v12.2h15.7V5.6h3.5v28.8h-3.5v-13.4h-15.7v13.4h-3.5V5.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M234.5,5.6h3.5v12.2h15.7V5.6h3.5v28.8h-3.5v-13.4h-15.7v13.4h-3.5V5.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M278.1,35.1c-2.2,0-4.3-.4-6.2-1.1s-3.5-1.8-4.9-3.2c-1.4-1.3-2.4-2.9-3.2-4.8-.8-1.9-1.1-3.9-1.1-6s.4-4.2,1.1-6c.8-1.9,1.8-3.5,3.2-4.8,1.4-1.3,3-2.4,4.9-3.2,1.9-.8,3.9-1.1,6.2-1.1s4.3.4,6.2,1.1c1.9.8,3.5,1.8,4.9,3.2,1.4,1.3,2.4,2.9,3.2,4.8.8,1.9,1.1,3.9,1.1,6s-.4,4.2-1.1,6c-.8,1.9-1.8,3.5-3.2,4.8-1.4,1.3-3,2.4-4.9,3.2s-3.9,1.1-6.2,1.1ZM278.1,31.9c1.7,0,3.3-.3,4.7-.9,1.4-.6,2.6-1.5,3.7-2.6,1-1.1,1.8-2.4,2.4-3.8.6-1.5.9-3,.9-4.7s-.3-3.2-.9-4.7c-.6-1.5-1.4-2.7-2.4-3.8-1-1.1-2.2-1.9-3.7-2.6-1.4-.6-3-.9-4.7-.9s-3.3.3-4.7.9c-1.4.6-2.6,1.5-3.7,2.6-1,1.1-1.8,2.4-2.4,3.8-.6,1.5-.9,3-.9,4.7s.3,3.2.9,4.7c.6,1.5,1.4,2.7,2.4,3.8,1,1.1,2.2,1.9,3.7,2.6,1.4.6,3,.9,4.7.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M299.1,5.6h8.7c1.4,0,2.6.1,3.9.4,1.2.3,2.3.7,3.3,1.3,1,.6,1.7,1.4,2.3,2.4.6,1,.9,2.3.9,3.8s-.3,2.9-.9,3.9c-.6,1-1.4,1.8-2.3,2.4-1,.6-2,1-3.1,1.3-1.1.2-2.2.4-3.2.4h-5.9v12.9h-3.5V5.6ZM302.5,18.3h5.9c1.7,0,3.2-.4,4.3-1.2,1.1-.8,1.6-2,1.6-3.6s-.5-2.8-1.6-3.6c-1.1-.8-2.5-1.2-4.3-1.2h-5.9v9.5Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "st0",
    x: 53.9,
    y: 5.6,
    width: 18.5,
    height: 3.2
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st0",
    x: 53.9,
    y: 17.6,
    width: 18.5,
    height: 3.2
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st0",
    x: 53.9,
    y: 31.1,
    width: 18.5,
    height: 3.2
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "st0",
    x: 198.2,
    y: 5.5,
    width: 18.5,
    height: 3.2
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st0",
    x: 198.2,
    y: 17.6,
    width: 18.5,
    height: 3.2
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st0",
    x: 198.2,
    y: 31.1,
    width: 18.5,
    height: 3.2
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "st0",
    x: 323.7,
    y: 5.6,
    width: 18.5,
    height: 3.2
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st0",
    x: 323.7,
    y: 17.6,
    width: 18.5,
    height: 3.2
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st0",
    x: 323.7,
    y: 31.1,
    width: 18.5,
    height: 3.2
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M53.8,56.1c.2.3.4.5.7.7.3.1.6.2.9.2s.4,0,.6,0c.2,0,.4-.2.5-.3.1-.1.2-.3.3-.4,0-.2.1-.4.1-.6s0-.4-.2-.6-.2-.3-.4-.4c-.2-.1-.4-.2-.6-.3-.2,0-.4-.1-.7-.2-.2,0-.4-.2-.7-.2-.2,0-.4-.2-.6-.4-.2-.1-.3-.3-.4-.6-.1-.2-.2-.5-.2-.8s0-.6.2-.8c.1-.2.3-.4.5-.6.2-.2.4-.3.7-.4.3,0,.5-.1.8-.1s.7,0,1,.2c.3.1.6.4.8.7l-.6.4c-.2-.2-.4-.4-.6-.5-.2-.1-.5-.2-.8-.2s-.4,0-.6,0c-.2,0-.4.1-.5.2-.1.1-.3.2-.3.4,0,.2-.1.4-.1.6,0,.3,0,.6.3.8.2.2.4.3.7.4.3.1.5.2.9.3.3,0,.6.2.9.3.3.1.5.3.7.6.2.2.3.6.3,1s0,.6-.2.8c-.1.2-.3.4-.5.6-.2.2-.4.3-.7.4-.3,0-.5.1-.8.1-.5,0-.9,0-1.3-.2s-.7-.4-1-.8l.6-.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M61,50.5h.6v3h3.9v-3h.6v6.9h-.6v-3.3h-3.9v3.3h-.6v-6.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M72.1,50.5h.7l2.9,6.9h-.7l-.8-1.8h-3.7l-.8,1.8h-.7l3-6.9ZM72.4,51.2l-1.6,3.8h3.2l-1.6-3.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M78.6,50.5h1.8c0,0,.2,0,.4,0,.2,0,.3,0,.5,0,.2,0,.4,0,.6.2.2,0,.4.2.5.3s.3.3.4.5c0,.2.1.5.1.8s0,.6-.2.8-.3.4-.4.5c-.2.1-.4.2-.6.3-.2,0-.4.1-.6.1l2,3.3h-.7l-1.9-3.3h-1.2v3.3h-.6v-6.9ZM79.3,53.5h1.4c.3,0,.6,0,.8-.1.2,0,.4-.2.5-.3.1-.1.2-.3.2-.4,0-.1,0-.3,0-.4s0-.2,0-.4c0-.1-.1-.3-.2-.4-.1-.1-.3-.2-.5-.3-.2,0-.5-.1-.8-.1h-1.4v2.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M86.3,50.5h4.2v.6h-3.6v2.5h3.4v.6h-3.4v2.7h3.7v.6h-4.4v-6.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M100.1,51.1h-2.4v-.6h5.4v.6h-2.4v6.3h-.6v-6.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M106.1,50.5h.6v3h3.9v-3h.6v6.9h-.6v-3.3h-3.9v3.3h-.6v-6.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M115.1,50.5h4.2v.6h-3.6v2.5h3.4v.6h-3.4v2.7h3.7v.6h-4.4v-6.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M127.2,50.5h1l2.5,5.8,2.5-5.8h.9v6.9h-.6v-6.1h0l-2.6,6.1h-.3l-2.7-6.1h0v6.1h-.6v-6.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M137.9,50.5h4.2v.6h-3.6v2.5h3.4v.6h-3.4v2.7h3.7v.6h-4.4v-6.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M145.8,56.1c.2.3.4.5.7.7.3.1.6.2.9.2s.4,0,.6,0c.2,0,.4-.2.5-.3.1-.1.2-.3.3-.4,0-.2.1-.4.1-.6s0-.4-.2-.6-.2-.3-.4-.4c-.2-.1-.4-.2-.6-.3-.2,0-.4-.1-.7-.2-.2,0-.4-.2-.7-.2-.2,0-.4-.2-.6-.4-.2-.1-.3-.3-.4-.6-.1-.2-.2-.5-.2-.8s0-.6.2-.8c.1-.2.3-.4.5-.6.2-.2.4-.3.7-.4.3,0,.5-.1.8-.1s.7,0,1,.2c.3.1.6.4.8.7l-.6.4c-.2-.2-.4-.4-.6-.5-.2-.1-.5-.2-.8-.2s-.4,0-.6,0c-.2,0-.4.1-.5.2-.1.1-.3.2-.3.4,0,.2-.1.4-.1.6,0,.3,0,.6.3.8.2.2.4.3.7.4.3.1.5.2.9.3.3,0,.6.2.9.3.3.1.5.3.7.6.2.2.3.6.3,1s0,.6-.2.8c-.1.2-.3.4-.5.6-.2.2-.4.3-.7.4-.3,0-.5.1-.8.1-.5,0-.9,0-1.3-.2s-.7-.4-1-.8l.6-.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M153.2,56.1c.2.3.4.5.7.7.3.1.6.2.9.2s.4,0,.6,0c.2,0,.4-.2.5-.3.1-.1.2-.3.3-.4,0-.2.1-.4.1-.6s0-.4-.2-.6-.2-.3-.4-.4c-.2-.1-.4-.2-.6-.3-.2,0-.4-.1-.7-.2-.2,0-.4-.2-.7-.2-.2,0-.4-.2-.6-.4-.2-.1-.3-.3-.4-.6-.1-.2-.2-.5-.2-.8s0-.6.2-.8c.1-.2.3-.4.5-.6.2-.2.4-.3.7-.4.3,0,.5-.1.8-.1s.7,0,1,.2c.3.1.6.4.8.7l-.6.4c-.2-.2-.4-.4-.6-.5-.2-.1-.5-.2-.8-.2s-.4,0-.6,0c-.2,0-.4.1-.5.2-.1.1-.3.2-.3.4,0,.2-.1.4-.1.6,0,.3,0,.6.3.8.2.2.4.3.7.4.3.1.5.2.9.3.3,0,.6.2.9.3.3.1.5.3.7.6.2.2.3.6.3,1s0,.6-.2.8c-.1.2-.3.4-.5.6-.2.2-.4.3-.7.4-.3,0-.5.1-.8.1-.5,0-.9,0-1.3-.2s-.7-.4-1-.8l.6-.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M162.5,50.5h.7l2.9,6.9h-.7l-.8-1.8h-3.7l-.8,1.8h-.7l3-6.9ZM162.8,51.2l-1.6,3.8h3.2l-1.6-3.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M174.7,56.9c-.4.2-.8.4-1.3.5-.4,0-.9.1-1.3.1s-1,0-1.4-.3c-.4-.2-.8-.4-1.1-.8s-.6-.7-.7-1.2c-.2-.4-.3-.9-.3-1.5s0-1,.3-1.5c.2-.4.4-.8.7-1.1.3-.3.7-.6,1.1-.8.4-.2.9-.3,1.4-.3,1,0,1.9.3,2.5,1l-.5.5c-.1-.1-.2-.2-.4-.3s-.3-.2-.5-.3c-.2,0-.4-.1-.6-.2s-.4,0-.6,0c-.4,0-.9,0-1.2.2-.4.2-.7.4-.9.6-.3.3-.4.6-.6,1-.1.4-.2.8-.2,1.2s0,.8.2,1.2c.1.4.3.7.6,1s.6.5.9.6c.4.2.8.2,1.2.2s.7,0,1,0c.3,0,.6-.2.9-.3v-2.3h-1.7v-.6h2.3v3.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M178.5,50.5h4.2v.6h-3.6v2.5h3.4v.6h-3.4v2.7h3.7v.6h-4.4v-6.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M190.3,53.9c0-.5,0-1,.3-1.5.2-.4.4-.8.7-1.1.3-.3.7-.6,1.1-.8.4-.2.9-.3,1.4-.3s1,0,1.4.3c.4.2.8.4,1.1.8.3.3.6.7.7,1.1.2.4.3.9.3,1.5s0,1-.3,1.5c-.2.4-.4.8-.7,1.2-.3.3-.7.6-1.1.8-.4.2-.9.3-1.4.3s-1,0-1.4-.3c-.4-.2-.8-.4-1.1-.8-.3-.3-.6-.7-.7-1.2-.2-.4-.3-.9-.3-1.5ZM190.9,53.9c0,.4,0,.8.2,1.2.1.4.3.7.6,1,.3.3.6.5.9.6.4.2.8.2,1.2.2s.9,0,1.2-.2c.4-.2.7-.4.9-.6s.4-.6.6-1c.1-.4.2-.8.2-1.2s0-.8-.2-1.2c-.1-.4-.3-.7-.6-1-.3-.3-.6-.5-.9-.6-.4-.2-.8-.2-1.2-.2s-.9,0-1.2.2c-.4.2-.7.4-.9.6-.3.3-.4.6-.6,1-.1.4-.2.8-.2,1.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M200.8,50.5h4.1v.6h-3.5v2.5h3.2v.6h-3.2v3.3h-.6v-6.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M212.6,50.5h.6v6.3h3.2v.6h-3.9v-6.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M219,53.9c0-.5,0-1,.3-1.5.2-.4.4-.8.7-1.1.3-.3.7-.6,1.1-.8.4-.2.9-.3,1.4-.3s1,0,1.4.3c.4.2.8.4,1.1.8.3.3.6.7.7,1.1.2.4.3.9.3,1.5s0,1-.3,1.5c-.2.4-.4.8-.7,1.2-.3.3-.7.6-1.1.8-.4.2-.9.3-1.4.3s-1,0-1.4-.3c-.4-.2-.8-.4-1.1-.8-.3-.3-.6-.7-.7-1.2-.2-.4-.3-.9-.3-1.5ZM219.7,53.9c0,.4,0,.8.2,1.2.1.4.3.7.6,1,.3.3.6.5.9.6.4.2.8.2,1.2.2s.9,0,1.2-.2c.4-.2.7-.4.9-.6s.4-.6.6-1c.1-.4.2-.8.2-1.2s0-.8-.2-1.2c-.1-.4-.3-.7-.6-1-.3-.3-.6-.5-.9-.6-.4-.2-.8-.2-1.2-.2s-.9,0-1.2.2c-.4.2-.7.4-.9.6-.3.3-.4.6-.6,1-.1.4-.2.8-.2,1.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M228.6,50.5h.7l2.2,6.1,2.2-6.1h.7l-2.6,6.9h-.6l-2.6-6.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M237.3,50.5h4.2v.6h-3.6v2.5h3.4v.6h-3.4v2.7h3.7v.6h-4.4v-6.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M251.6,50.5h.7l2.9,6.9h-.7l-.8-1.8h-3.7l-.8,1.8h-.7l3-6.9ZM251.9,51.2l-1.6,3.8h3.2l-1.6-3.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M258.1,50.5h.8l4.2,6h0v-6h.6v6.9h-.8l-4.2-6h0v6h-.6v-6.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M267.6,50.5h2.1c.6,0,1.1,0,1.5.2s.8.3,1,.6.5.5.7.8.3.5.4.8c0,.3.1.5.1.7,0,.2,0,.3,0,.4s0,.2,0,.4c0,.2,0,.4-.1.7,0,.3-.2.5-.4.8s-.4.5-.7.8c-.3.2-.6.4-1,.6s-.9.2-1.5.2h-2.1v-6.9ZM268.2,56.8h1.3c.5,0,.9,0,1.3-.2.4-.1.7-.3,1-.5.3-.2.5-.5.7-.9s.3-.8.3-1.3,0-.9-.3-1.3-.4-.7-.7-.9-.6-.4-1-.5c-.4-.1-.8-.2-1.3-.2h-1.3v5.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M281.3,50.5h.6v3h3.9v-3h.6v6.9h-.6v-3.3h-3.9v3.3h-.6v-6.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M289.8,53.9c0-.5,0-1,.3-1.5.2-.4.4-.8.7-1.1.3-.3.7-.6,1.1-.8.4-.2.9-.3,1.4-.3s1,0,1.4.3c.4.2.8.4,1.1.8.3.3.6.7.7,1.1.2.4.3.9.3,1.5s0,1-.3,1.5c-.2.4-.4.8-.7,1.2-.3.3-.7.6-1.1.8-.4.2-.9.3-1.4.3s-1,0-1.4-.3c-.4-.2-.8-.4-1.1-.8-.3-.3-.6-.7-.7-1.2-.2-.4-.3-.9-.3-1.5ZM290.5,53.9c0,.4,0,.8.2,1.2.1.4.3.7.6,1,.3.3.6.5.9.6.4.2.8.2,1.2.2s.9,0,1.2-.2c.4-.2.7-.4.9-.6s.4-.6.6-1c.1-.4.2-.8.2-1.2s0-.8-.2-1.2c-.1-.4-.3-.7-.6-1-.3-.3-.6-.5-.9-.6-.4-.2-.8-.2-1.2-.2s-.9,0-1.2.2c-.4.2-.7.4-.9.6-.3.3-.4.6-.6,1-.1.4-.2.8-.2,1.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M300.4,50.5h2c.2,0,.5,0,.8,0,.3,0,.5.2.7.3.2.1.4.3.5.6.1.2.2.5.2.9s0,.6-.2.8c-.1.2-.3.4-.5.6-.2.1-.4.3-.7.3-.3,0-.5.1-.8.1h-1.5v3.3h-.6v-6.9ZM301,53.5h1.5c.2,0,.4,0,.5,0,.2,0,.3-.1.5-.2.1,0,.2-.2.3-.4,0-.2.1-.3.1-.6s0-.4-.1-.6c0-.2-.2-.3-.3-.4-.1-.1-.3-.2-.5-.2-.2,0-.4,0-.5,0h-1.4v2.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M307.9,50.5h4.2v.6h-3.6v2.5h3.4v.6h-3.4v2.7h3.7v.6h-4.4v-6.9Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWthLogo);
export default __webpack_public_path__ + "static/media/wth-logo.5fada23628861fe4f8df6229315cb86f.svg";
export { ForwardRef as ReactComponent };